import { fetchWithAuth } from '../helpers';
import { getApiUrl } from '../config/api';

const getAll = async () => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getStudentsWithClassNames = async () => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/with-class-names`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const create = (student: any) => {
  const formData = new FormData();
  
  // Append các fields vào FormData (bao gồm cả empty string để BE xử lý đúng)
  if (student.name !== undefined && student.name !== null) formData.append('name', student.name);
  if (student.dateOfBirth !== undefined && student.dateOfBirth !== null) formData.append('dateOfBirth', student.dateOfBirth);
  if (student.phoneNumber !== undefined && student.phoneNumber !== null) formData.append('phoneNumber', student.phoneNumber);
  if (student.fbLink !== undefined && student.fbLink !== null) formData.append('fbLink', student.fbLink);
  if (student.note !== undefined && student.note !== null) formData.append('note', student.note);
  if (student.classId !== undefined && student.classId !== null) formData.append('classId', student.classId);
  if (student.startDate !== undefined && student.startDate !== null) formData.append('startDate', student.startDate);
  if (student.bankAccountId !== undefined && student.bankAccountId !== null && student.bankAccountId !== '') formData.append('bankAccountId', String(student.bankAccountId));
  if (student.address !== undefined && student.address !== null) formData.append('address', student.address);
  
  // Nếu có avatar (base64), convert sang Blob và append
  if (student.avatar) {
    // Convert base64 to blob
    const base64Data = student.avatar.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/jpeg' });
    formData.append('avatar', blob, 'avatar.jpg');
  }

  return fetchWithAuth(`${getApiUrl()}/api/students/`, {
    method: 'POST',
    headers: { "ngrok-skip-browser-warning": "69420" },
    body: formData
  })
    .then(handleResponse);
};

function getById(id: any) {
  return fetchWithAuth(`${getApiUrl()}/api/students/${id}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  })
  .then(handleResponse)
  .then((student) => {
    return student
  });
}

const update = async (student: any) => {
  const formData = new FormData();
  
  // Append các fields vào FormData (bao gồm cả empty string để BE xử lý đúng)
  if (student.name !== undefined && student.name !== null) formData.append('name', student.name);
  if (student.dateOfBirth !== undefined && student.dateOfBirth !== null) formData.append('dateOfBirth', student.dateOfBirth);
  if (student.phoneNumber !== undefined && student.phoneNumber !== null) formData.append('phoneNumber', student.phoneNumber);
  if (student.fbLink !== undefined && student.fbLink !== null) formData.append('fbLink', student.fbLink);
  if (student.note !== undefined && student.note !== null) formData.append('note', student.note);
  if (student.classId !== undefined && student.classId !== null) formData.append('classId', student.classId);
  if (student.startDate !== undefined && student.startDate !== null) formData.append('startDate', student.startDate);
  if (student.gift !== undefined && student.gift !== null) formData.append('gift', student.gift.toString());
  if (student.bankAccountId !== undefined && student.bankAccountId !== null && student.bankAccountId !== '') formData.append('bankAccountId', String(student.bankAccountId));
  
  // Nếu có avatar (base64), convert sang Blob và append
  if (student.avatar && student.avatar.startsWith('data:')) {
    // Chỉ convert nếu là base64 mới (không phải URL cũ)
    const base64Data = student.avatar.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/jpeg' });
    formData.append('avatar', blob, 'avatar.jpg');
  }

  const response = await fetchWithAuth(`${getApiUrl()}/api/students/${student.id}`, {
    method: 'PUT',
    headers: { "ngrok-skip-browser-warning": "69420" },
    body: formData,
  });
  return handleResponse(response);
};

const remove = async (studentId: number) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/${studentId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

// Cho nghỉ học (soft delete với ngày nghỉ thực tế)
const archive = async (studentId: number, archiveDate?: string) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/${studentId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420" },
    body: JSON.stringify({ archiveDate: archiveDate || new Date().toISOString().split('T')[0] }),
  });
  return handleResponse(response);
};

// Cho học lại (restore)
const restore = async (studentId: number, data: { classId?: number; startDate?: string }) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/${studentId}/restore`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420" },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

// Lấy danh sách học sinh đã nghỉ
const getArchived = async () => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/archived`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

// Xóa hẳn học sinh đã nghỉ (giữ lại học phí)
const permanentDelete = async (studentId: number) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/${studentId}/permanent`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const addListFromGoogleSheet = async () => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/add-student-list-from-excel`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420" }
  });
  return handleResponse(response);
};

const getWrongQuestionsStats = async () => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/wrong-questions-stats`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getRetryExamQuestions = async () => {
  console.log('[studentService] Calling getRetryExamQuestions...');
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/retry-exam-questions`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  console.log('[studentService] Response received:', response.status);
  const result = await handleResponse(response);
  console.log('[studentService] handleResponse returned:', result);
  return result;
};

const submitRetryExam = async (answers: any) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/submit-retry-exam`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "69420" },
    body: JSON.stringify({ answers })
  });
  return handleResponse(response);
};

function handleResponse(response: any) {
  return response.text().then((text: string) => {
    console.log('[handleResponse] Text length:', text?.length, 'Status:', response.status);
    const data = text && JSON.parse(text);
    console.log('[handleResponse] Parsed data:', !!data);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      console.log('[handleResponse] Error:', error);
      return Promise.reject(error);
    }
    console.log('[handleResponse] Success, returning data');
    return data;
  });
}

const getSiblings = async (studentId: number) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/${studentId}/siblings`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getBatchSiblings = async (studentIds: number[]) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/batch/siblings`, {
    method: 'POST',
    headers: { 
      "ngrok-skip-browser-warning": "69420",
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ studentIds }),
  });
  return handleResponse(response);
};

const updateSiblings = async (studentId: number, siblingIds: number[]) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/${studentId}/siblings`, {
    method: 'PUT',
    headers: { 
      "ngrok-skip-browser-warning": "69420",
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ siblingIds }),
  });
  return handleResponse(response);
};

const getFlashcardStats = async () => {
  try {
    const response = await fetchWithAuth(`${getApiUrl()}/api/flashcards/stats`, {
      method: 'GET',
      headers: { "ngrok-skip-browser-warning": "69420" },
    });
    return handleResponse(response);
  } catch (error) {
    // Return default stats if endpoint doesn't exist
    return {
      totalSets: 0,
      totalCards: 0,
      masteredCards: 0,
      learningCards: 0,
    };
  }
};

const changePassword = async (oldPassword: string, newPassword: string) => {
  const response = await fetchWithAuth(`${getApiUrl()}/api/students/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420"
    },
    body: JSON.stringify({ oldPassword, newPassword })
  });
  return handleResponse(response);
};

export const studentService = {
  getAll,
  getStudentsWithClassNames,
  getById,
  create,
  update,
  remove,
  archive,
  restore,
  getArchived,
  permanentDelete,
  addListFromGoogleSheet,
  getWrongQuestionsStats,
  getRetryExamQuestions,
  submitRetryExam,
  getSiblings,
  getBatchSiblings,
  updateSiblings,
  getFlashcardStats,
  changePassword,
};
